<div class="container">
  <div class="section" style="text-align: center">
    <h2>Vallourec Upload Portal</h2>
    <h4>Secure File Sharing</h4>
  </div>
  <div class="section">
    <h6>Disclaimer:</h6>
    By clicking "USE THIS SERVICE", you agree with:<br>
    <ul>
      <li>use this service exclusively in your professional activity for the Vallourec Group.</li>
      <li>do not disclose information that could jeopardize the knowledge of Vallourec or its partners and associates.
      </li>
      <li> do not attempt to bypass computer security rules implemented.</li>
    </ul>
    <h6>New release note:</h6>
    An update of Vallourec Upload has taken place.<br>
    This update has slightly modified the system for external users.<br><br>
    From now on, the accounts of the external users will be temporary for at least 2 weeks,
    they will receive by email a password valid as long as their account is active.<br>
    After <b>2 weeks</b>, if a new file or a sharing authorization is made,
    a new password will be send to the user.<br><br>
    <b>Important:</b> If you don't have access to the application anymore,
    please ask to the Vallourec employee that gave you the access.<br><br>
    For more information, you can click on the <b>"Guide" button</b> at the top right of the web page site.
  </div>
  <div class="section" style="text-align: center">
    <button class="vlr-cta-btn vlr-icon-btn" (click)="openSignInDialog()">
      <mat-icon>exit_to_app</mat-icon>
      <span>USE THIS SERVICE</span>
    </button>
  </div>
</div>

